/**
 * VW-E2 — persistent "Made with ManticsCore — paste a link" growth footer.
 *
 * Mounted on every public clip/share page and inside the full `PublicFooter`
 * so the capture CTA is always one tap away. Deliberately unobtrusive: one
 * line, one link, no layout ownership.
 */
import { track } from '@/lib/analytics';

/** Web capture surface — the landing page's paste-a-link box. */
export const CAPTURE_HREF = '/#try-it';

export default function MadeWithFooter({
  source = 'public',
  className = '',
}: {
  /** Analytics label for which page carried the CTA. */
  source?: string;
  className?: string;
}) {
  return (
    <div
      data-testid="made-with-footer"
      className={`border-t border-white/[0.08] px-6 py-5 text-center ${className}`}
    >
      <a
        href={CAPTURE_HREF}
        onClick={() => track('made_with_footer_clicked', { source })}
        className="ios-metadata text-xs text-ios-muted transition-colors hover:text-ios-accent-text"
      >
        Made with <span className="font-semibold text-ios-secondary">ManticsCore</span>
        {' — '}
        <span className="underline underline-offset-4">paste a link</span>
      </a>
    </div>
  );
}
